import { render, staticRenderFns } from "./403.vue?vue&type=template&id=bab1aba8&scoped=true&"
import script from "./403.vue?vue&type=script&lang=js&"
export * from "./403.vue?vue&type=script&lang=js&"
import style0 from "./403.vue?vue&type=style&index=0&id=bab1aba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1aba8",
  null
  
)

export default component.exports